var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SetupEffortGauge"},[_vm._m(0),_c('div',{staticClass:"_label",style:(_vm.computedLabelStyle)},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_gauge"},[_c('h6',[_vm._v("LOW")]),_c('h6',[_vm._v("HIGH")])])
}]

export { render, staticRenderFns }